// src/pages/SellerIntelligence/Orders/OrderAnalytics.js
//
// Order Analytics. Sellers see orders one at a time and never the shape of the
// order book: what it is made of, when demand arrives, and how much customers
// buy at a time.
//
// One shared window governs every region, so the whole page describes one
// period.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import { WindowControl, useWindowControl } from '../components/WindowControl';
import CategoryBreakdown from './components/CategoryBreakdown';
import ChannelBreakdown from './components/ChannelBreakdown';
import PeakTimes from './components/PeakTimes';
import ItemsPerOrder from './components/ItemsPerOrder';
import RepeatPurchase from './components/RepeatPurchase';
import ReturnRates from './components/ReturnRates';

const OrderAnalytics = () => {
  const navigate = useNavigate();
  const control = useWindowControl();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/orders')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Order Analytics</h1></div>
          <p>
            The shape of your order book — what it is made of, when it arrives,
            and how much customers buy at a time.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <WindowControl control={control} />


        <CategoryBreakdown window={control.applied} onLoadingChange={control.track('categoryBreakdown')} />

        <ChannelBreakdown window={control.applied} onLoadingChange={control.track('channelBreakdown')} />

        <PeakTimes window={control.applied} onLoadingChange={control.track('peakTimes')} />

        <ItemsPerOrder window={control.applied} onLoadingChange={control.track('itemsPerOrder')} />

        <RepeatPurchase window={control.applied} onLoadingChange={control.track('repeatPurchase')} />

        <ReturnRates window={control.applied} onLoadingChange={control.track('returnRates')} />
      </div>
    </div>
  );
};

export default OrderAnalytics;
